import { render, staticRenderFns } from "./LegendBar.vue?vue&type=template&id=6c6b6a75&"
import script from "./LegendBar.vue?vue&type=script&lang=js&"
export * from "./LegendBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports